import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { showLoader, hideLoader } from './actions'

function mapDispatchToState(dispatch) {
    return bindActionCreators({ showLoader, hideLoader }, dispatch)
}

export default (InnerComponent) => {
    @connect(null, mapDispatchToState)
    class hocLoader extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocLoader
}
